<template>
  <div id="pricing">
    <!-- Loader -->
    <loader v-if="loaderActive"></loader>

    <form id="frm_pay" name="frm_pay" method="POST" novalidate>
      <!--------------------------->
      <!-- ::: 공통 인증 요청 값 -->
      <!--------------------------->
      <input type="hidden" id="service" name="service" v-model="basicInfo.service">         <!-- service -->
      <input type="hidden" id="EP_mall_id" name="EP_mall_id" v-model="basicInfo.EP_mall_id">         <!-- 가맹점ID-->
      <input type="hidden" id="EP_mall_nm" name="EP_mall_nm" v-model="basicInfo.EP_mall_nm">         <!-- 가맹점명-->
      <input type="hidden" id="EP_order_no" name="EP_order_no" v-model="basicInfo.EP_order_no">         <!-- 주문번호-->
      <input type="hidden" id="EP_currency" name="EP_currency" v-model="basicInfo.EP_currency">       <!-- 통화코드 // 00 : 원화-->
      <input type="hidden" id="EP_return_url" name="EP_return_url" v-model="basicInfo.EP_return_url">
      <input type="hidden" id="EP_ci_url" name="EP_ci_url" v-model="basicInfo.EP_ci_url">         <!-- CI LOGO URL // -->
      <input type="hidden" id="EP_lang_flag" name="EP_lang_flag" v-model="basicInfo.EP_lang_flag">         <!-- 언어 // -->
      <input type="hidden" id="EP_charset" name="EP_charset" v-model="basicInfo.EP_charset">
      <input type="hidden" id="EP_user_id" name="EP_user_id" v-model="basicInfo.EP_user_id">         <!-- 가맹점 고객ID // -->
      <input type="hidden" id="EP_memb_user_no" name="EP_memb_user_no" v-model="basicInfo.EP_memb_user_no">         <!-- 가맹점 고객일련번호 // -->
      <input type="hidden" id="EP_user_nm" name="EP_user_nm" v-model="basicInfo.EP_user_nm">         <!-- 가맹점 고객명 // -->
      <input type="hidden" id="EP_user_mail" name="EP_user_mail" v-model="basicInfo.EP_user_mail">
      <input type="hidden" id="EP_user_phone1" name="EP_user_phone1" v-model="basicInfo.EP_user_phone1">
      <input type="hidden" id="EP_user_phone2" name="EP_user_phone2" v-model="basicInfo.EP_user_phone2">         <!-- 가맹점 고객 연락처2 // -->
      <input type="hidden" id="EP_user_addr" name="EP_user_addr" v-model="basicInfo.EP_user_addr">         <!-- 가맹점 고객 주소 // -->
      <input type="hidden" id="EP_user_define1" name="EP_user_define1" v-model="basicInfo.EP_user_define1">         <!-- 가맹점 필드1 // -->
      <input type="hidden" id="EP_user_define2" name="EP_user_define2" v-model="basicInfo.EP_user_define2">         <!-- 가맹점 필드2 // -->
      <input type="hidden" id="EP_user_define3" name="EP_user_define3" v-model="basicInfo.EP_user_define3">         <!-- 가맹점 필드3 // -->
      <input type="hidden" id="EP_user_define4" name="EP_user_define4" v-model="basicInfo.EP_user_define4">         <!-- 가맹점 필드4 // -->
      <input type="hidden" id="EP_user_define5" name="EP_user_define5" v-model="basicInfo.EP_user_define5">         <!-- 가맹점 필드5 // -->
      <input type="hidden" id="EP_user_define6" name="EP_user_define6" v-model="basicInfo.EP_user_define6">         <!-- 가맹점 필드6 // -->
      <input type="hidden" id="EP_product_type" name="EP_product_type" v-model="basicInfo.EP_product_type">         <!-- 상품정보구분 // -->
      <input type="hidden" id="EP_product_expr" name="EP_product_expr" v-model="basicInfo.EP_product_expr">         <!-- 서비스 기간 // (YYYYMMDD) -->
      <input type="hidden" id="EP_product_nm" name="EP_product_nm" v-model="basicInfo.EP_product_nm">    <!-- 상품명 -->
      <input type="hidden" id="EP_product_amt" name="EP_product_amt" v-model="basicInfo.EP_product_amt"> <!-- 상품금액 -->
      <input type="hidden" id="EP_disp_cash_yn" name="EP_disp_cash_yn" v-model="basicInfo.EP_disp_cash_yn">
      <input type="hidden" id="EP_easypay_url" name="EP_easypay_url" v-model="basicInfo.EP_easypay_url">
      <input type="hidden" id="EP_window_type" name="EP_window_type" v-model="basicInfo.EP_window_type">         <!-- 결제모듈 호출 URL -->
      <input type="hidden" id="EP_pay_type" name="EP_pay_type" v-model="basicInfo.EP_pay_type">                    <!-- 결제수단 -->
      <input type="hidden" id="EP_cert_type" name="EP_cert_type" v-model="basicInfo.EP_cert_type">                    <!--  -->
      <input type="hidden" id="EP_usedcard_code" name="EP_usedcard_code" v-model="basicInfo.EP_usedcard_code">
      <input type="hidden" id="EP_quota" name="EP_quota" v-model="basicInfo.EP_quota">      <!-- 할부개월 (카드코드-할부개월) -->
      <input type="hidden" id="EP_os_cert_flag" name="EP_os_cert_flag" v-model="basicInfo.EP_os_cert_flag">     <!-- 해외안심클릭 사용여부(변경불가) // -->
      <input type="hidden" id="EP_noinst_flag" name="EP_noinst_flag" v-model="basicInfo.EP_noinst_flag">      <!-- 무이자 여부 (Y/N) // -->
      <input type="hidden" id="EP_noinst_term" name="EP_noinst_term" v-model="basicInfo.EP_noinst_term">
      <input type="hidden" id="EP_set_point_card_yn" name="EP_set_point_card_yn" v-model="basicInfo.EP_set_point_card_yn">
      <input type="hidden" id="EP_point_card" name="EP_point_card" v-model="basicInfo.EP_point_card">      <!-- 포인트카드 LIST  // -->
      <input type="hidden" id="EP_join_cd" name="EP_join_cd" v-model="basicInfo.EP_join_cd">      <!-- 조인코드 // -->
      <input type="hidden" id="EP_kmotion_useyn" name="EP_kmotion_useyn" v-model="basicInfo.EP_kmotion_useyn">     <!-- 국민앱카드 사용유무 (Y/N)// -->
      <input type="hidden" id="EP_vacct_bank" name="EP_vacct_bank" v-model="basicInfo.EP_vacct_bank">      <!-- 가상계좌 사용가능한 은행 LIST // -->
      <input type="hidden" id="EP_vacct_end_date" name="EP_vacct_end_date" v-model="basicInfo.EP_vacct_end_date">      <!-- 입금 만료 날짜 // -->
      <input type="hidden" id="EP_vacct_end_time" name="EP_vacct_end_time" v-model="basicInfo.EP_vacct_end_time">      <!-- 입금 만료 시간 // -->
      <input type="hidden" id="EP_prepaid_cp" name="EP_prepaid_cp" v-model="basicInfo.EP_prepaid_cp">
      <input type="hidden" id="EP_res_cd" name="EP_res_cd" v-model="basicInfo.EP_res_cd">      <!--  응답코드 // -->
      <input type="hidden" id="EP_res_msg" name="EP_res_msg" v-model="basicInfo.EP_res_msg">      <!--  응답메세지 // -->
      <input type="hidden" id="EP_tr_cd" name="EP_tr_cd" v-model="basicInfo.EP_tr_cd">      <!--  결제창 요청구분 // -->
      <input type="hidden" id="EP_ret_pay_type" name="EP_ret_pay_type" v-model="basicInfo.EP_ret_pay_type">      <!--  결제수단 // -->
      <input type="hidden" id="EP_ret_complex_yn" name="EP_ret_complex_yn" v-model="basicInfo.EP_ret_complex_yn">      <!--  복합결제 여부 (Y/N) // -->
      <input type="hidden" id="EP_card_code" name="EP_card_code" v-model="basicInfo.EP_card_code">      <!--  카드코드 (ISP:KVP카드코드 MPI:카드코드) // -->
      <input type="hidden" id="EP_eci_code" name="EP_eci_code" v-model="basicInfo.EP_eci_code">      <!--  MPI인 경우 ECI코드 // -->
      <input type="hidden" id="EP_card_req_type" name="EP_card_req_type" v-model="basicInfo.EP_card_req_type">      <!--  거래구분 // -->
      <input type="hidden" id="EP_save_useyn" name="EP_save_useyn" v-model="basicInfo.EP_save_useyn">      <!--  카드사 세이브 여부 (Y/N) // -->
      <input type="hidden" id="EP_trace_no" name="EP_trace_no" v-model="basicInfo.EP_trace_no">      <!--  추적번호 // -->
      <input type="hidden" id="EP_sessionkey" name="EP_sessionkey" v-model="basicInfo.EP_sessionkey">      <!--  세션키 // -->
      <input type="hidden" id="EP_encrypt_data" name="EP_encrypt_data" v-model="basicInfo.EP_encrypt_data">      <!--  암호화전문 // -->
      <input type="hidden" id="EP_spay_cp" name="EP_spay_cp" v-model="basicInfo.EP_spay_cp">      <!--  간편결제 CP 코드 // -->
      <input type="hidden" id="EP_card_prefix" name="EP_card_prefix" v-model="basicInfo.EP_card_prefix">      <!--  신용카드prefix // -->
      <input type="hidden" id="EP_card_no_7" name="EP_card_no_7" v-model="basicInfo.EP_card_no_7">      <!--  신용카드번호 앞7자리 // -->
    </form>

    <form name="frm_mobile_pay" method="post" novalidate>
      <input type="hidden" name="service" v-model="basicInfo.service"/>  <!-- 서비스명 -->
      <input type="hidden" id="easypay_url" name="easypay_url" v-model="basicInfo.easypay_url">
      <input type="hidden" id="easypay_url2" name="easypay_url2" v-model="basicInfo.easypay_url2">
      <input type='hidden' id="sp_mall_id" name="sp_mall_id" v-model="basicInfo.sp_mall_id"> <!-- 가맹점 ID(*) -->
      <input type="hidden" id="sp_mall_nm" name="sp_mall_nm" v-model="basicInfo.sp_mall_nm">               <!--[선택]가맹점명 -->
      <input type="hidden" id="sp_order_no" name="sp_order_no" v-model="basicInfo.sp_order_no">               <!--[필수]가맹점 주문번호(인증응답) -->
      <input type="hidden" id="sp_pay_type" name="sp_pay_type" v-model="basicInfo.sp_pay_type">
      <input type="hidden" id="sp_currency" name="sp_currency" v-model="basicInfo.sp_currency">               <!--[필수]통화코드(수정불가) -->
      <input type="hidden" id="sp_product_nm" name="sp_product_nm" v-model="basicInfo.sp_product_nm">               <!--[필수]통화코드(수정불가) -->
      <input type="hidden" id="sp_product_amt" name="sp_product_amt" v-model="basicInfo.sp_product_amt">               <!--[필수]통화코드(수정불가) -->
      <input type="hidden" id="sp_lang_flag" name="sp_lang_flag" v-model="basicInfo.sp_lang_flag">               <!--[선택]언어 -->
      <input type="hidden" id="sp_charset" name="sp_charset" v-model="basicInfo.sp_charset">               <!--[선택]가맹점 charset -->
      <input type="hidden" id="sp_user_id" name="sp_user_id" v-model="basicInfo.sp_user_id">               <!--[선택]가맹점 고객ID -->
      <input type="hidden" id="sp_memb_user_no" name="sp_memb_user_no" v-model="basicInfo.sp_memb_user_no"/>               <!--[선택]가맹점 고객일련번호 -->
      <input type="hidden" id="sp_user_nm" name="sp_user_nm" v-model="basicInfo.sp_user_nm">               <!--[선택]가맹점 고객명 -->
      <input type="hidden" id="sp_user_mail" name="sp_user_mail" v-model="basicInfo.sp_user_mail"/>               <!--[선택]가맹점 고객 E-mail -->
      <input type="hidden" id="sp_user_phone1" name="sp_user_phone1" v-model="basicInfo.sp_user_phone1"/>               <!--[선택]가맹점 고객 연락처1 -->
      <input type="hidden" id="sp_user_phone2" name="sp_user_phone2" v-model="basicInfo.sp_user_phone2"/>               <!--[선택]가맹점 고객 연락처2 -->
      <input type="hidden" id="sp_user_addr" name="sp_user_addr" v-model="basicInfo.sp_user_addr"/>               <!--[선택]가맹점 고객 주소 -->
      <input type="hidden" id="sp_product_type" name="sp_product_type" v-model="basicInfo.sp_product_type">               <!--[선택]상품정보구분 -->
      <input type="hidden" id="sp_product_expr" name="sp_product_expr" v-model="basicInfo.sp_product_expr"/>               <!--[선택]서비스 기간 -->
      <input type="hidden" id="sp_app_scheme" name="sp_app_scheme" v-model="basicInfo.sp_app_scheme"/>               <!--[선택]가맹점 APP scheme -->
      <input type="hidden" id="sp_return_url" name="sp_return_url" v-model="basicInfo.sp_return_url"/>
      <input type="hidden" id="sp_user_define1" name="sp_user_define1" v-model="basicInfo.sp_user_define1"/>               <!--[선택]가맹점 필드1 -->
      <input type="hidden" id="sp_user_define2" name="sp_user_define2" v-model="basicInfo.sp_user_define2"/>               <!--[선택]가맹점 필드2 -->
      <input type="hidden" id="sp_user_define3" name="sp_user_define3" v-model="basicInfo.sp_user_define3"/>               <!--[선택]가맹점 필드3 -->
      <input type="hidden" id="sp_user_define4" name="sp_user_define4" v-model="basicInfo.sp_user_define4"/>               <!--[선택]가맹점 필드4 -->
      <input type="hidden" id="sp_user_define5" name="sp_user_define5" v-model="basicInfo.sp_user_define5"/>               <!--[선택]가맹점 필드5 -->
      <input type="hidden" id="sp_user_define6" name="sp_user_define6" v-model="basicInfo.sp_user_define6"/>               <!--[선택]가맹점 필드6 -->
      <input type="hidden" id="sp_usedcard_code" name="sp_usedcard_code" v-model="basicInfo.sp_usedcard_code"/>               <!--[선택]사용가능카드 LIST -->
      <input type="hidden" id="sp_quota" name="sp_quota" v-model="basicInfo.sp_quota"/>               <!--[선택]할부개월 -->
      <input type="hidden" id="sp_os_cert_flag" name="sp_os_cert_flag" v-model="basicInfo.sp_os_cert_flag">               <!--[선택]해외안심클릭 사용여부-->
      <input type="hidden" id="sp_noinst_flag" name="sp_noinst_flag" v-model="basicInfo.sp_noinst_flag"/>               <!--[선택]무이자 여부(Y/N)-->
      <input type="hidden" id="sp_noinst_term" name="sp_noinst_term" v-model="basicInfo.sp_noinst_term">               <!--[선택]무이자 기간 -->
      <input type="hidden" id="sp_set_point_card_yn" name="sp_set_point_card_yn" v-model="basicInfo.sp_set_point_card_yn"/>               <!--[선택]카드사포인트 사용여부(Y/N)-->
      <input type="hidden" id="sp_point_card" name="sp_point_card" v-model="basicInfo.sp_point_card">               <!--[선택]포인트카드 LIST(카드코드-더할 할부개월) -->
      <input type="hidden" id="sp_join_cd" name="sp_join_cd" v-model="basicInfo.sp_join_cd"/>               <!--[선택]조인코드 -->
      <input type="hidden" id="sp_vacct_bank" name="sp_vacct_bank" v-model="basicInfo.sp_vacct_bank"/>               <!--[선택]가상계좌 사용가능한 은행 LIST -->
      <input type="hidden" id="sp_vacct_end_date" name="sp_vacct_end_date" v-model="basicInfo.sp_vacct_end_date">               <!--[선택]입금 만료 날짜 -->
      <input type="hidden" id="sp_vacct_end_time" name="sp_vacct_end_time" v-model="basicInfo.sp_vacct_end_time">               <!--[선택]입금 만료 시간 -->
      <input type="hidden" id="sp_prepaid_cp" name="sp_prepaid_cp" v-model="basicInfo.sp_prepaid_cp"/>               <!--[선택]선불카드 CP -->
      <input type="hidden" id="sp_res_cd" name="sp_res_cd" v-model="basicInfo.sp_res_cd"/>         <!-- [필수]응답코드        -->
      <input type="hidden" id="sp_res_msg" name="sp_res_msg" v-model="basicInfo.sp_res_msg"/>         <!-- [필수]응답메시지      -->
      <input type="hidden" id="sp_tr_cd" name="sp_tr_cd" v-model="basicInfo.sp_tr_cd"/>         <!-- [필수]결제창 요청구분 -->
      <input type="hidden" id="sp_ret_pay_type" name="sp_ret_pay_type" v-model="basicInfo.sp_ret_pay_type"/>         <!-- [필수]결제수단        -->
      <input type="hidden" id="sp_trace_no" name="sp_trace_no" v-model="basicInfo.sp_trace_no"/>         <!-- [선택]추적번호        -->
      <input type="hidden" id="sp_sessionkey" name="sp_sessionkey" v-model="basicInfo.sp_sessionkey"/>         <!-- [필수]세션키          -->
      <input type="hidden" id="sp_encrypt_data" name="sp_encrypt_data" v-model="basicInfo.sp_encrypt_data"/>         <!-- [필수]암호화전문      -->
      <input type="hidden" id="sp_mobilereserved1" name="sp_mobilereserved1" v-model="basicInfo.sp_mobilereserved1"/>         <!-- [선택]여유필드        -->
      <input type="hidden" id="sp_mobilereserved2" name="sp_mobilereserved2" v-model="basicInfo.sp_mobilereserved2"/>         <!-- [선택]여유필드        -->
      <input type="hidden" id="sp_reserved1" name="sp_reserved1" v-model="basicInfo.sp_reserved1"/>         <!-- [선택]여유필드        -->
      <input type="hidden" id="sp_reserved2" name="sp_reserved2" v-model="basicInfo.sp_reserved2"/>         <!-- [선택]여유필드        -->
      <input type="hidden" id="sp_reserved3" name="sp_reserved3" v-model="basicInfo.sp_reserved3"/>         <!-- [선택]여유필드        -->
      <input type="hidden" id="sp_reserved4" name="sp_reserved4" v-model="basicInfo.sp_reserved4"/>         <!-- [선택]여유필드        -->
      <input type="hidden" id="sp_card_code" name="sp_card_code" v-model="basicInfo.sp_card_code"/>         <!-- [필수]카드코드               -->
      <input type="hidden" id="sp_eci_code" name="sp_eci_code" v-model="basicInfo.sp_eci_code"/>         <!-- [선택]ECI코드(MPI인 경우)    -->
      <input type="hidden" id="sp_card_req_type" name="sp_card_req_type" v-model="basicInfo.sp_card_req_type"/>
      <input type="hidden" id="sp_save_useyn" name="sp_save_useyn" v-model="basicInfo.sp_save_useyn"/>         <!-- [선택]카드사 세이브 여부     -->
      <input type="hidden" id="sp_card_prefix" name="sp_card_prefix" v-model="basicInfo.sp_card_prefix"/>         <!-- [선택]신용카드 Prefix        -->
      <input type="hidden" id="sp_card_no_7" name="sp_card_no_7" v-model="basicInfo.sp_card_no_7"/>         <!-- [선택]신용카드번호 앞7자리   -->
      <input type="hidden" id="sp_spay_cp" name="sp_spay_cp" v-model="basicInfo.sp_spay_cp"/>          <!-- [선택]간편결제 CP코드 -->
      <input type="hidden" id="sp_cert_type" name="sp_cert_type" v-model="basicInfo.sp_cert_type"/>
      <input type="hidden" id="sp_disp_cash_yn" name="sp_disp_cash_yn" v-model="basicInfo.sp_disp_cash_yn"/>
      <input type="hidden" id="sp_kmotion_useyn" name="sp_kmotion_useyn" v-model="basicInfo.sp_kmotion_useyn"/>
      <input type="hidden" id="sp_window_type" name="sp_window_type" v-model="basicInfo.sp_window_type">
    </form>

    <!-- 화면 영역 -->
    <section id="banner">
      <div class="container">
        <p>비즈해줌 이용권</p>
        <h1>가장 앞서가는 태양광 기업 서비스를<br><span>원하는 기간동안 무제한</span>으로 이용해보세요!</h1>
      </div>
    </section>
    <section id="plan">
      <div class="container">
        <div class="row plan-title">
          <h4 class="sub-title col-xs-6">이용권 안내</h4>
          <div class="col-xs-6 text-right">
            <button class="hz-btn-default hz-btn-md" @click="showCouponModal">쿠폰등록</button>
          </div>
        </div>
        <div v-if="productLoader" class="loader-wrap">
          <div class="loader-content">
            <bar-loader></bar-loader>
          </div>
        </div>
        <ul v-if="productList.length > 0 && !productLoader" class="row plan-type">
          <li :class="productColumnClass" v-for="product in productList" :key="product.code">
            <div :class="['card', {'active': selectedType === product.code}]">
              <div :class="['card-header', { 'bg-grey': selectedType }]">
                <p class="description">{{ product.description }}</p>
                <p class="name">{{ product.name }}</p>
              </div>
              <div class="card-body">
                <div class="discount">
                  <span v-if="product.discount_rate > 0">{{ product.discount_rate }}%<br>할인</span>
                  <span v-else-if="product.tag !== ''">{{ product.tag }}</span>
                </div>
                <div class="price">
                  <span v-if="product.discount_rate > 0" style="text-decoration: line-through;">정가 {{ product.origin_price | changePriceUnit }}만원</span>
                  <span v-else-if="product.tag === 'BEST'">정가</span>
                  <span v-else style="display: block; margin-bottom: 24px;"></span>
                  <p>{{ product.price | changePriceUnit }}만원</p>
                </div>
              </div>
              <div class="card-footer">
                <button type="button" class="hz-btn-md hz-btn-default w-100" @click="selectedType = product.code">선택하기</button>
              </div>
            </div>
          </li>
        </ul>
        <div class="row plan-notice">
          <div class="col-xs-12">
            <h5>유의사항</h5>
            <ul class="">
              <li>중도 해지 시 위약금이 발생할 수 있습니다.</li>
              <li>모든 서비스는 일시납으로 진행됩니다. (VAT포함)</li>
              <li>카드 결제 시, 무이자 할부 가능합니다. (카드사별로 무이자 할부 기간 상이)</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section id="payment">
      <div class="container">
        <div v-if="!selectedType" class="row not-selected visible-xs">
          <div class="col-xs-12">
              <p class="none">요금제를 선택해주세요.</p>
          </div>
        </div>
        <div v-if="selectedType" class="row selected visible-xs">
          <div class="col-xs-6">
            <p class="name">{{ productName }}</p>
          </div>
          <div class="col-xs-6">
            <p class="price">{{ productPrice | intcomma }}원</p>
          </div>
          <div class="col-xs-12">
            <p class="vat">VAT포함</p>
          </div>
        </div>
        <div class="row agreement">
          <div class="col-xs-12">
            <div class="checkbox">
            <label>
              <input type="checkbox" v-model="isAgree">
              <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
            </label>
            </div>
            <p><a href="https://biz.haezoom.com/media/terms/bizhaezoom_terms_2020.pdf" target="_blank">서비스 이용약관</a>에 동의하며 결제 진행에 동의합니다.</p>
          </div>
          <div class="col-xs-12">
            <button type="button" class="hz-btn-primary hz-btn-lg" @click="startEasyPay">결제하기</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title" :size="notifyModal.size" :fields="notifyModal.fields"></modal>

    <!-- 쿠폰입력창 -->
    <div id="couponModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="couponModalLabel'" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header border-none">
            <h5 class="modal-title" id="couponModalLabel" style="display: inline-block">쿠폰 등록</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body border-none">
            <div class="row">
              <div class="col-sm-8 position-relative">
                <input type="text"
                       placeholder="쿠폰코드를 입력해주세요."
                       maxlength="50"
                       :class="couponInputClass"
                       :readonly="couponRegistering"
                       @keyup.enter="addCoupon"
                       v-model.trim="couponCode">
                <p v-show="couponError" class="is-invalid-text">{{ couponErrorMessage }}</p>
              </div>
              <div class="col-sm-4">
                <button type="button" class="hz-btn-default hz-btn-lg w-100" @click="addCoupon">등록</button>
              </div>
            </div>
          </div>
          <div class="modal-footer border-none">
            <p>쿠폰 사용 내역은 <a href="#" class="link" @click.prevent="toMycoupon">이용권관리/쿠폰함</a> 메뉴에서 확인 가능합니다.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  'use strict'

  import api from '@/api/pricing'
  import couponApi from '@/api/coupon'
  import { mapActions, mapGetters } from 'vuex'
  import Modal from 'common/components/Modal'
  import Loader from 'common/components/Loader'
  import BarLoader from 'common/components/BarLoader'

  export default {
    name: 'pricing',
    components: {
      Modal,
      Loader,
      BarLoader
    },
    data () {
      return {
        loaderActive: false,
        isAgree: false,
        productLoader: true,
        load_easypay_js: false,
        couponError: false,
        couponRegistering: false,
        selectedType: '',
        couponCode: '',
        couponErrorMessage: '',
        productList: [],
        // 전달용 값이 많아 비워두겠다..
        basicInfo: {
          is_mobile: false,
          service: '',
          easypay_url: '',
          easypay_url2: '',
          EP_mall_id: '',
          EP_mall_nm: '해줌',
          EP_order_no: '',
          EP_currency: '00',
          EP_return_url: '',
          EP_ci_url: '',
          EP_lang_flag: 'KOR',
          EP_charset: 'UTF-8',
          EP_user_id: '',
          EP_memb_user_no: '',
          EP_user_nm: '',
          EP_user_mail: '',
          EP_user_phone1: '',
          EP_user_phone2: '',
          EP_user_addr: '',
          EP_user_define1: '',
          EP_user_define2: '',
          EP_user_define3: '',
          EP_user_define4: '',
          EP_user_define5: '',
          EP_user_define6: '',
          EP_product_type: '0',
          EP_product_expr: '',
          EP_product_nm: '',
          EP_product_amt: '',
          EP_disp_cash_yn: '',
          EP_easypay_url: '',
          EP_window_type: 'iframe',
          EP_pay_type: '11',
          EP_cert_type: '',
          EP_usedcard_code: '',
          EP_quota: '',
          EP_os_cert_flag: '2',
          EP_noinst_flag: '',
          EP_noinst_term: '029-02:03',
          EP_set_point_card_yn: '',
          EP_point_card: '029-40',
          EP_join_cd: '',
          EP_kmotion_useyn: 'Y',
          EP_vacct_bank: '',
          EP_vacct_end_date: '29991231',
          EP_vacct_end_time: '000000',
          EP_prepaid_cp: '',
          EP_res_cd: '',
          EP_res_msg: '',
          EP_tr_cd: '',
          EP_ret_pay_type: '',
          EP_ret_complex_yn: '',
          EP_card_code: '',
          EP_eci_code: '',
          EP_card_req_type: '',
          EP_save_useyn: '',
          EP_trace_no: '',
          EP_sessionkey: '',
          EP_encrypt_data: '',
          EP_spay_cp: '',
          EP_card_prefix: '',
          EP_card_no_7: '',
          sp_mall_id: '',
          sp_mall_nm: '해줌',
          sp_order_no: '',
          sp_pay_type: '11',
          sp_currency: '00',
          sp_product_nm: '',
          sp_product_amt: '',
          sp_lang_flag: 'KOR',
          sp_charset: 'UTF-8',
          sp_user_id: '',
          sp_memb_user_no: '',
          sp_user_nm: '',
          sp_user_mail: '',
          sp_user_phone1: '',
          sp_user_phone2: '',
          sp_user_addr: '',
          sp_product_type: '0',
          sp_product_expr: '',
          sp_app_scheme: '',
          sp_return_url: '',
          sp_user_define1: '',
          sp_user_define2: '',
          sp_user_define3: '',
          sp_user_define4: '',
          sp_user_define5: '',
          sp_user_define6: '',
          sp_usedcard_code: '',
          sp_quota: '',
          sp_os_cert_flag: '2',
          sp_noinst_flag: '',
          sp_noinst_term: '029-02:03',
          sp_set_point_card_yn: '',
          sp_point_card: '029-40',
          sp_join_cd: '',
          sp_vacct_bank: '',
          sp_vacct_end_date: '29991231',
          sp_vacct_end_time: '153025',
          sp_res_cd: '',
          sp_res_msg: '',
          sp_tr_cd: '',
          sp_ret_pay_type: '',
          sp_trace_no: '',
          sp_prepaid_cp: '',
          sp_sessionkey: '',
          sp_encrypt_data: '',
          sp_mobilereserved1: '',
          sp_mobilereserved2: '',
          sp_reserved1: '',
          sp_reserved2: '',
          sp_reserved3: '',
          sp_reserved4: '',
          sp_card_code: '',
          sp_eci_code: '',
          sp_card_req_type: '',
          sp_save_useyn: '',
          sp_card_prefix: '',
          sp_card_no_7: '',
          sp_spay_cp: '',
          sp_cert_type: '',
          sp_disp_cash_yn: '',
          sp_kmotion_useyn: '',
          sp_window_type: 'iframe'
        },
        choiceInfo: {
          product_nm: 'Basic',
          product_amt: 150000
        },
        result: {
          account_no: '',
          acquirer_cd: '031',
          acquirer_nm: 'Payzone TestCard',
          amount: '150000',
          ars_no: '',
          auth_id: '',
          auth_no: '00761793',
          bank_cd: '',
          bank_nm: '',
          billid: '',
          bk_pay_yn: 'N',
          canc_acq_date: '',
          canc_date: '',
          card_biz_gubun: 'P',
          card_gubun: 'N',
          card_no: '4047-****-****-0401',
          cash_auth_no: '',
          cash_auth_type: '',
          cash_auth_value: '',
          cash_issue_type: '',
          cash_res_cd: '',
          cash_res_msg: '',
          cash_tran_date: '',
          cno: '19120315300310571034',
          complex_yn: 'N',
          cp_cd: '',
          cpon_auth_no: '',
          cpon_flag: 'N',
          cpon_no: '',
          cpon_tran_date: '',
          deposit_nm: '',
          escrow_yn: 'N',
          expire_date: '',
          install_period: '00',
          issuer_cd: '031',
          issuer_nm: 'OK:00761793',
          mall_id: '',
          mob_ansim_yn: '',
          mobile_no: '',
          noint: '00',
          order_no: 'BIZ-201912031459-48',
          part_cancel_yn: 'Y',
          pay_type: '11',
          refund_date: '',
          rem_amt: '',
          remain_cpon: '',
          res_cd: '0000',
          res_msg: '결제가 성공적으로 완료되었습니다.',
          service: 'biz',
          source: '',
          stat_cd: 'TS03',
          stat_msg: '매입요청',
          tran_date: '2019-12-03 15:30:43',
          used_cpon: ''
        },
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      productColumnClass () {
        // 상품 갯수에 따라 부트스트랩 Column 클래스를 할당한다.
        const length = this.productList.length
        const column = parseInt(12 / length)

        return `col-md-${column}`
      },
      productName () {
        // 선택된 상품에 이름을 출력한다.
        const list = this.productList
        const selected = this.selectedType
        const product = _.find(list, {'code': selected})
        const productName = product ? product.name : ''

        return productName
      },
      productPrice () {
        // 선택된 상품에 가격을 출력한다.
        const list = this.productList
        const selected = this.selectedType
        const product = _.find(list, {'code': selected})
        const productPrice = product ? product.price : 0

        return productPrice
      },
      couponInputClass () {
        // 쿠폰 입력창에 클래스 반환
        const isEroor = this.couponError
        const inputClass = ['hz-input-default', 'hz-input-lg', 'w-100']

        // 유효하지 않은 쿠폰을 입력했을 경우
        if (isEroor) {
          inputClass.push('is-invalid')
        }

        return inputClass
      }
    },
    watch: {
      couponCode () {
        // 쿠폰 입력 오류가 발생한 상황에서 코드르 새로 입력할 경우, 에러 초기화
        if (this.couponError) {
          this.couponError = false
          this.couponErrorMessage = ''
        }
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage',
        'getPricingInfo'
      ]),
      init () {
        // 데이터 요청
        this.getBasicOrderInfo()
        this.getPricingProduct()

        // 윈도우 객체에 폼 데이터 전송 함수추가
        window.f_submit = this.f_submit
      },
      addCoupon () {
        if (this.couponCode && !this.couponRegistering && !this.couponError) {
          this.couponRegistering = true

          // 쿠폰 등록 API 요청
          couponApi.addCoupon({promotion_code: this.couponCode}, response => {
            if (response.error) {
              this.couponError = true
              this.couponRegistering = false
              this.couponErrorMessage = response.data.message
            } else {
              this.hideCouponModal()
              this.showToastMessage('쿠폰 등록 완료')
              this.$router.push({name: 'mycoupon', query: {tab: 'coupon'}})
            }
          })
        }
      },
      getPricingProduct () {
        // 이용권 상품 목록 불러오기
        api.getPricingProduct(response => {
          if (response.error) {
            this.showToastMessage('샹품목록 불러오기 실패! 시스템 관리자에게 문의하세요.')
            console.log('get basic order info error!', response)
          } else {
            // 데이터 초기화
            this.productLoader = false
            this.productList = response
          }
        })
      },
      getBasicOrderInfo () {
        const vm = this

        // 카드 결제에 필요한 정보 불러오기
        api.getBasicOrderInfo('', response => {
          if (response.error) {
            // API 호출 실패 시
            vm.showToastMessage('카드결제 기본정보 불러오기 실패! 시스템 관리자에게 문의하세요.')
            console.log('get basic order info error!', response)
          } else {
            // set data
            // vm.data.basicInfo = Object.assign({}, vm.data.basicInfo, response)
            // vm.basicInfo = $.extend(true, {}, response)
            vm.basicInfo.EP_mall_id = response.mall_id
            vm.basicInfo.EP_order_no = response.order_no
            vm.basicInfo.EP_return_url = response.ep_return_url
            vm.basicInfo.EP_user_id = response.user_id
            vm.basicInfo.EP_user_nm = response.name
            vm.basicInfo.EP_user_mail = response.email
            vm.basicInfo.EP_user_phone1 = response.contact
            vm.basicInfo.EP_easypay_url = response.ep_easypay_url
            vm.basicInfo.service = response.service
            vm.basicInfo.is_mobile = response.is_mobile
            vm.basicInfo.easypay_url = response.easypay_url
            vm.basicInfo.easypay_url2 = response.easypay_url2
            vm.basicInfo.sp_mall_id = response.mall_id
            vm.basicInfo.sp_order_no = response.order_no
            vm.basicInfo.sp_user_id = response.user_id
            vm.basicInfo.sp_user_nm = response.name
            vm.basicInfo.sp_user_mail = response.email
            vm.basicInfo.sp_user_phone1 = response.contact
            vm.basicInfo.sp_return_url = response.sp_return_url

            // easy pay 외부 js 로딩
            vm.loadEasyPay()
          }
        })
      },
      loadEasyPay () {
        const vm = this
        const url = vm.basicInfo.easypay_url
        $.getScript(url, function (data, textStatus, jqxhr) {
          if (jqxhr.status === 200) {
            vm.load_easypay_js = true
          } else {
            vm.load_easypay_js = false
          }
        })
      },
      startEasyPay () {
        const vm = this
        const frmPay = document.frm_pay
        const frmMobilePay = document.frm_mobile_pay
        const isMobile = vm.basicInfo.is_mobile

        // 요금선택 여부 확인
        if (!vm.selectedType) {
          vm.notifyModal.fields[0].message = ['이용권을 선택해주세요.']
          vm.$refs.notifyModal.show()
          return false
        }

        // 서비스 이용약관 동의여부 확인
        if (!vm.isAgree) {
          vm.notifyModal.fields[0].message = ['서비스 이용약관 및 결제진행에 동의해주세요.']
          vm.$refs.notifyModal.show()
          return false
        }

        // 카드결제 초기화 여부 확인
        if (!vm.load_easypay_js) {
          vm.showToastMessage('카드결제 호출 실패! 시스템 관리자에게 문의하세요.')
          return false
        }

        // 상품명, 상품가격 초기화
        vm.setProductInfo()

        if (isMobile) {
          /* UTF-8 사용가맹점의 경우 EP_charset 값 셋팅 필수 */
          if (frmMobilePay.sp_charset.value === 'UTF-8') {
            // 한글이 들어가는 값은 모두 encoding 필수.
            frmMobilePay.sp_mall_nm.value = encodeURIComponent(frmMobilePay.sp_mall_nm.value)
            frmMobilePay.sp_product_nm.value = encodeURIComponent(frmMobilePay.sp_product_nm.value)
            frmMobilePay.sp_user_nm.value = encodeURIComponent(frmMobilePay.sp_user_nm.value)
            frmMobilePay.sp_user_addr.value = encodeURIComponent(frmMobilePay.sp_user_addr.value)
          }
          const mobileUrl = '../easypay/order_req/mobile/?service=' + vm.basicInfo.service
          window.easypay_card_webpay(frmMobilePay, mobileUrl, '_self', '0', '0', 'iframe', 30)
        } else {
          if (frmPay.EP_charset.value === 'UTF-8') {
            // encoding 된 값은 모두 decoding 필수.
            frmPay.EP_mall_nm.value = encodeURIComponent(frmPay.EP_mall_nm.value)
            frmPay.EP_product_nm.value = encodeURIComponent(frmPay.EP_product_nm.value)
            frmPay.EP_user_nm.value = encodeURIComponent(frmPay.EP_user_nm.value)
            frmPay.EP_user_addr.value = encodeURIComponent(frmPay.EP_user_addr.value)
          }
          const pcUrl = '../easypay/order_req/pc/?service=' + vm.basicInfo.service
          window.easypay_webpay(frmPay, pcUrl, 'hiddenifr', '0', '0', 'iframe', 30)
        }
      },
      setProductInfo () {
        const name = this.productName
        const price = this.productPrice

        // 상품명 초기화
        document.getElementById('EP_product_nm').value = name
        document.getElementById('sp_product_nm').value = name

        // 상품가격 초기화
        document.getElementById('EP_product_amt').value = price
        document.getElementById('sp_product_amt').value = price
      },
      set_value_to_data () {
        const vm = this
        const frmPay = document.frm_pay
        const frmMobilePay = document.frm_mobile_pay
        vm.basicInfo.service = frmPay.service.value
        vm.basicInfo.easypay_url = frmMobilePay.easypay_url.value
        vm.basicInfo.easypay_url2 = frmMobilePay.easypay_url2.value

        vm.basicInfo.EP_mall_id = frmPay.EP_mall_id.value
        vm.basicInfo.EP_mall_nm = frmPay.EP_mall_nm.value
        vm.basicInfo.EP_order_no = frmPay.EP_order_no.value
        vm.basicInfo.EP_currency = frmPay.EP_currency.value
        vm.basicInfo.EP_return_url = frmPay.EP_return_url.value
        vm.basicInfo.EP_ci_url = frmPay.EP_ci_url.value
        vm.basicInfo.EP_lang_flag = frmPay.EP_lang_flag.value
        vm.basicInfo.EP_charset = frmPay.EP_charset.value
        vm.basicInfo.EP_user_id = frmPay.EP_user_id.value
        vm.basicInfo.EP_memb_user_no = frmPay.EP_memb_user_no.value
        vm.basicInfo.EP_user_nm = frmPay.EP_user_nm.value
        vm.basicInfo.EP_user_mail = frmPay.EP_user_mail.value
        vm.basicInfo.EP_user_phone1 = frmPay.EP_user_phone1.value
        vm.basicInfo.EP_user_phone2 = frmPay.EP_user_phone2.value
        vm.basicInfo.EP_user_addr = frmPay.EP_user_addr.value
        vm.basicInfo.EP_user_define1 = frmPay.EP_user_define1.value
        vm.basicInfo.EP_user_define2 = frmPay.EP_user_define2.value
        vm.basicInfo.EP_user_define3 = frmPay.EP_user_define3.value
        vm.basicInfo.EP_user_define4 = frmPay.EP_user_define4.value
        vm.basicInfo.EP_user_define5 = frmPay.EP_user_define5.value
        vm.basicInfo.EP_user_define6 = frmPay.EP_user_define6.value
        vm.basicInfo.EP_product_type = frmPay.EP_product_type.value
        vm.basicInfo.EP_product_expr = frmPay.EP_product_expr.value
        vm.basicInfo.EP_product_nm = frmPay.EP_product_nm.value
        vm.basicInfo.EP_product_amt = frmPay.EP_product_amt.value
        vm.basicInfo.EP_disp_cash_yn = frmPay.EP_disp_cash_yn.value
        vm.basicInfo.EP_easypay_url = frmPay.EP_easypay_url.value
        vm.basicInfo.EP_window_type = frmPay.EP_window_type.value
        vm.basicInfo.EP_pay_type = frmPay.EP_pay_type.value
        vm.basicInfo.EP_cert_type = frmPay.EP_cert_type.value
        vm.basicInfo.EP_usedcard_code = frmPay.EP_usedcard_code.value
        vm.basicInfo.EP_quota = frmPay.EP_quota.value
        vm.basicInfo.EP_os_cert_flag = frmPay.EP_os_cert_flag.value
        vm.basicInfo.EP_noinst_flag = frmPay.EP_noinst_flag.value
        vm.basicInfo.EP_noinst_term = frmPay.EP_noinst_term.value
        vm.basicInfo.EP_set_point_card_yn = frmPay.EP_set_point_card_yn.value
        vm.basicInfo.EP_point_card = frmPay.EP_point_card.value
        vm.basicInfo.EP_join_cd = frmPay.EP_join_cd.value
        vm.basicInfo.EP_kmotion_useyn = frmPay.EP_kmotion_useyn.value
        vm.basicInfo.EP_vacct_bank = frmPay.EP_vacct_bank.value
        vm.basicInfo.EP_vacct_end_date = frmPay.EP_vacct_end_date.value
        vm.basicInfo.EP_vacct_end_time = frmPay.EP_vacct_end_time.value
        vm.basicInfo.EP_prepaid_cp = frmPay.EP_prepaid_cp.value
        vm.basicInfo.EP_res_cd = frmPay.EP_res_cd.value
        vm.basicInfo.EP_res_msg = frmPay.EP_res_msg.value
        vm.basicInfo.EP_tr_cd = frmPay.EP_tr_cd.value
        vm.basicInfo.EP_ret_pay_type = frmPay.EP_ret_pay_type.value
        vm.basicInfo.EP_ret_complex_yn = frmPay.EP_ret_complex_yn.value
        vm.basicInfo.EP_card_code = frmPay.EP_card_code.value
        vm.basicInfo.EP_eci_code = frmPay.EP_eci_code.value
        vm.basicInfo.EP_card_req_type = frmPay.EP_card_req_type.value
        vm.basicInfo.EP_save_useyn = frmPay.EP_save_useyn.value
        vm.basicInfo.EP_trace_no = frmPay.EP_trace_no.value
        vm.basicInfo.EP_sessionkey = frmPay.EP_sessionkey.value
        vm.basicInfo.EP_encrypt_data = frmPay.EP_encrypt_data.value
        vm.basicInfo.EP_spay_cp = frmPay.EP_spay_cp.value
        vm.basicInfo.EP_card_prefix = frmPay.EP_card_prefix.value
        vm.basicInfo.EP_card_no_7 = frmPay.EP_card_no_7.value

        vm.basicInfo.sp_mall_id = frmMobilePay.sp_mall_id.value
        vm.basicInfo.sp_mall_nm = frmMobilePay.sp_mall_nm.value
        vm.basicInfo.sp_order_no = frmMobilePay.sp_order_no.value
        vm.basicInfo.sp_pay_type = frmMobilePay.sp_pay_type.value
        vm.basicInfo.sp_currency = frmMobilePay.sp_currency.value
        vm.basicInfo.sp_product_nm = frmMobilePay.sp_product_nm.value
        vm.basicInfo.sp_product_amt = frmMobilePay.sp_product_amt.value
        vm.basicInfo.sp_lang_flag = frmMobilePay.sp_lang_flag.value
        vm.basicInfo.sp_charset = frmMobilePay.sp_charset.value
        vm.basicInfo.sp_user_id = frmMobilePay.sp_user_id.value
        vm.basicInfo.sp_memb_user_no = frmMobilePay.sp_memb_user_no.value
        vm.basicInfo.sp_user_nm = frmMobilePay.sp_user_nm.value
        vm.basicInfo.sp_user_mail = frmMobilePay.sp_user_mail.value
        vm.basicInfo.sp_user_phone1 = frmMobilePay.sp_user_phone1.value
        vm.basicInfo.sp_user_phone2 = frmMobilePay.sp_user_phone2.value
        vm.basicInfo.sp_user_addr = frmMobilePay.sp_user_addr.value
        vm.basicInfo.sp_product_type = frmMobilePay.sp_product_type.value
        vm.basicInfo.sp_product_expr = frmMobilePay.sp_product_expr.value
        vm.basicInfo.sp_app_scheme = frmMobilePay.sp_app_scheme.value
        vm.basicInfo.sp_return_url = frmMobilePay.sp_return_url.value
        vm.basicInfo.sp_user_define1 = frmMobilePay.sp_user_define1.value
        vm.basicInfo.sp_user_define2 = frmMobilePay.sp_user_define2.value
        vm.basicInfo.sp_user_define3 = frmMobilePay.sp_user_define3.value
        vm.basicInfo.sp_user_define4 = frmMobilePay.sp_user_define4.value
        vm.basicInfo.sp_user_define5 = frmMobilePay.sp_user_define5.value
        vm.basicInfo.sp_user_define6 = frmMobilePay.sp_user_define6.value
        vm.basicInfo.sp_usedcard_code = frmMobilePay.sp_usedcard_code.value
        vm.basicInfo.sp_quota = frmMobilePay.sp_quota.value
        vm.basicInfo.sp_os_cert_flag = frmMobilePay.sp_os_cert_flag.value
        vm.basicInfo.sp_noinst_flag = frmMobilePay.sp_noinst_flag.value
        vm.basicInfo.sp_noinst_term = frmMobilePay.sp_noinst_term.value
        vm.basicInfo.sp_set_point_card_yn = frmMobilePay.sp_set_point_card_yn.value
        vm.basicInfo.sp_point_card = frmMobilePay.sp_point_card.value
        vm.basicInfo.sp_join_cd = frmMobilePay.sp_join_cd.value
        vm.basicInfo.sp_vacct_bank = frmMobilePay.sp_vacct_bank.value
        vm.basicInfo.sp_vacct_end_date = frmMobilePay.sp_vacct_end_date.value
        vm.basicInfo.sp_vacct_end_time = frmMobilePay.sp_vacct_end_time.value
        vm.basicInfo.sp_res_cd = frmMobilePay.sp_res_cd.value
        vm.basicInfo.sp_res_msg = frmMobilePay.sp_res_msg.value
        vm.basicInfo.sp_tr_cd = frmMobilePay.sp_tr_cd.value
        vm.basicInfo.sp_ret_pay_type = frmMobilePay.sp_ret_pay_type.value
        vm.basicInfo.sp_trace_no = frmMobilePay.sp_trace_no.value
        vm.basicInfo.sp_prepaid_cp = frmMobilePay.sp_prepaid_cp.value
        vm.basicInfo.sp_sessionkey = frmMobilePay.sp_sessionkey.value
        vm.basicInfo.sp_encrypt_data = frmMobilePay.sp_encrypt_data.value
        vm.basicInfo.sp_mobilereserved1 = frmMobilePay.sp_mobilereserved1.value
        vm.basicInfo.sp_mobilereserved2 = frmMobilePay.sp_mobilereserved2.value
        vm.basicInfo.sp_reserved1 = frmMobilePay.sp_reserved1.value
        vm.basicInfo.sp_reserved2 = frmMobilePay.sp_reserved2.value
        vm.basicInfo.sp_reserved3 = frmMobilePay.sp_reserved3.value
        vm.basicInfo.sp_reserved4 = frmMobilePay.sp_reserved4.value
        vm.basicInfo.sp_card_code = frmMobilePay.sp_card_code.value
        vm.basicInfo.sp_eci_code = frmMobilePay.sp_eci_code.value
        vm.basicInfo.sp_card_req_type = frmMobilePay.sp_card_req_type.value
        vm.basicInfo.sp_save_useyn = frmMobilePay.sp_save_useyn.value
        vm.basicInfo.sp_card_prefix = frmMobilePay.sp_card_prefix.value
        vm.basicInfo.sp_card_no_7 = frmMobilePay.sp_card_no_7.value
        vm.basicInfo.sp_spay_cp = frmMobilePay.sp_spay_cp.value
        vm.basicInfo.sp_cert_type = frmMobilePay.sp_cert_type.value
        vm.basicInfo.sp_disp_cash_yn = frmMobilePay.sp_disp_cash_yn.value
        vm.basicInfo.sp_kmotion_useyn = frmMobilePay.sp_kmotion_useyn.value
        vm.basicInfo.sp_window_type = frmMobilePay.sp_window_type.value
      },
      f_submit () {
        const vm = this
        const frmPay = document.frm_pay
        const frmMobilePay = document.frm_mobile_pay

        if (vm.basicInfo.is_mobile && frmMobilePay.sp_charset.value === 'UTF-8') {
          // 인증요청 시 인코딩 한 값은 승인요청 시 디코딩 처리해야함.
          frmMobilePay.sp_mall_nm.value = decodeURIComponent(frmMobilePay.sp_mall_nm.value)
          frmMobilePay.sp_product_nm.value = decodeURIComponent(frmMobilePay.sp_product_nm.value)
          frmMobilePay.sp_user_nm.value = decodeURIComponent(frmMobilePay.sp_user_nm.value)
          frmMobilePay.sp_user_addr.value = decodeURIComponent(frmMobilePay.sp_user_addr.value)
          // frmMobilePay.target = '_self'
          // frmMobilePay.action = '../easypay/easypay_request/mobile/?service=' + vm.basicInfo.service
          // frmMobilePay.submit()
        } else if (frmPay.EP_charset.value === 'UTF-8') {
          // encoding 된 값은 모두 decoding 필수.
          frmPay.EP_mall_nm.value = decodeURIComponent(frmPay.EP_mall_nm.value)
          frmPay.EP_product_nm.value = decodeURIComponent(frmPay.EP_product_nm.value)
          frmPay.EP_user_nm.value = decodeURIComponent(frmPay.EP_user_nm.value)
          frmPay.EP_user_addr.value = decodeURIComponent(frmPay.EP_user_addr.value)
          // frmPay.target = '_blank'
          // frmPay.action = '../easypay/easypay_request/pc/?service=' + vm.basicInfo.service
          // frmPay.submit()
        }

        // 로더 활성화
        vm.loaderActive = true

        // basicInfo에 폼 정보를 담는다.
        vm.set_value_to_data()

        // 인증된 결제정보로 결제승인을 요청한다.
        api.easypayRequest(vm.basicInfo, response => {
          if (response.error) {
            // API 호출 실패 시
            vm.loaderActive = false
            vm.showToastMessage('카드결제 진행 오류! 시스템 관리자에게 문의하세요.')
            console.log('get basic order info error!', response)
          } else {
            // console.log(response.res_cd)
            if (response.res_cd === '0000') {
              // 사용자 결제정보 업데이트
              this.getPricingInfo().catch(error => {
                this.showToastMessage('사용자 결제정보 업데이트 실패')
                console.log('error get Pricing Info!', error)
              })

              // 결제완료 페이지 이동
              this.$router.push({name: 'pricingResult', params: response})
            } else {
              vm.showToastMessage(response.res_msg)
            }

            // 로더 비활성화
            vm.loaderActive = false
          }
        })
      },
      toMycoupon () {
        this.$router.push({name: 'mycoupon'})
        this.hideCouponModal()
      },
      showCouponModal () {
        $('#couponModal').modal('show')
      },
      hideCouponModal () {
        $('#couponModal').modal('hide')
      }
    },
    filters: {
      changePriceUnit (val) {
        // 상품 가격을 만원단위로 변경하여 반환
        return val ? val / 10000 : '-'
      }
    },
    created: function () {
      const token = localStorage.getItem('_t')

      // 토큰이 없을 경우, 로그인 페이지로 이동
      if (!token) {
        this.$router.push({name: 'login'})
        return false
      }

      // 토큰 유효성 검증
      this.$store.dispatch('inspectToken', token).then(() => {
        this.init()
      })
    },
    mounted: function () {
      // 쿠폰입력창이 닫힐때마다 쿠폰번호 및 유효상태 초기화
      $('#couponModal').on('hidden.bs.modal', () => {
        this.couponCode = ''
        this.couponErrorMessage = ''
        this.couponError = false
        this.couponRegistering = false
      })
    }
  }
</script>

<style lang="scss" scoped>
  #pricing {
    word-break: keep-all;

    #banner {
      padding: 64px 16px;
      background-color: #f3f4f8;

      p {
        margin-bottom: 24px;
        font-size: 20px;
        font-weight: bold;
        line-height: 1.4;
        letter-spacing: -0.8px;
        color: #868e96;
      }

      h1 {
        margin: 0;
        font-size: 40px;
        font-weight: bold;
        line-height: 1.25;
        letter-spacing: -2.42px;
        color: $header-color;

        span {
          color: #9b88e9;
        }
      }

      @media (max-width: 767px) {
        padding: 32px 0;
        text-align: center;

        h1 {
          font-size: 32px;
        }
        p {
          margin-bottom: 16px;
          font-size: 14px;
        }
      }
    }

    #plan {
      padding: 40px 16px;

      .plan-title {
        margin-bottom: 24px;
      }

      .plan-title button {
        width: 168px;

        @media (max-width: 767px) {
          width: 107px;
        }
      }

      .plan-type {
        margin-bottom: 40px;
        list-style: none;

        li {
          padding: 8px;

          @media (max-width: 997px) {
            padding: 4px 4px 24px 4px;
          }
        }
      }

      .plan-notice {
        h5 {
          margin: 0 0 8px 0;
          font-size: 20px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.4;
          letter-spacing: -0.8px;
          color: $header-color;
        }

        ul {
          list-style-type: none;
          padding-left: 16px;
        }

        ul > li:before {
          content: '–';
          position: absolute;
          margin-left: -1.1em;
        }

        ul > li {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.57;
          letter-spacing: -0.58px;
          color: #868e96;
        }
      }

      .card {
        border-radius: 4px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        border: solid 2px #e9ecef;

        .bg-grey {
          background-color: #adb5bd;
        }

        &.active {
          border: solid 2px #9b88e9;
        }

        &.active, &:hover {
          .card-header {
            background-color: $primary-color-v2
          }
        }

        &-header {
          padding: 24px;
          color: $hzc-white;
          background-color: #5f78a4;
          text-align: center;

          .description {
            margin-bottom: 4px;
            font-size: 20px;
            line-height: 1.5;
            letter-spacing: -0.75px;
          }

          .name {
            margin: 0;
            font-size: 32px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.25;
            letter-spacing: -1.3px;
          }

          @media (max-width: 1199px) {
            padding: 24px 16px;
          }

          @media (max-width: 997px) {
            padding: 16px 0;
            text-align: center;
          }
        }

        &-body {
          display: flex;
          align-items: center;
          padding: 16px 24px;

          .discount {
            display: table;
            width: 57px;
            height: 52px;
            border-radius: 4px;
            background-color: #f5f2fc;
            text-align: center;

            span {
              display: table-cell;
              vertical-align: middle;
              font-size: 14px;
              font-weight: bold;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.36;
              letter-spacing: -0.58px;
              text-align: center;
              color: #7c61e8;
            }
          }

          .price {
            display: table;
            width: calc(100% - 57px);
            text-align: right;

            span {
              font-size: 16px;
              line-height: 1.5;
              letter-spacing: -0.7px;
              color: #adb5bd;
            }

            p {
              margin: 0;
              font-size: 26px;
              font-weight: bold;
              line-height: 1.31;
              letter-spacing: -1px;
              color: $font-color;
            }
          }
        }

        &-footer {
          padding: 16px 24px;

          @media (max-width: 767px) {
            padding-top: 0;
          }
        }
      }
    }

    #payment {
      padding: 8px 16px 48px;
      background-color: $hzc-white;

      .not-selected {
        display: none;

        p {
          font-size: 20px;
          font-weight: bold;
          line-height: 1.4;
          letter-spacing: -0.8px;
          color: #868e96;
        }
      }

      .selected {
        display: none;
        .name {
          margin: 0;
          font-size: 22px;
          font-weight: bold;
          line-height: 34px;
          letter-spacing: -0.9px;
          color: $font-color;
        }

        .price {
          margin: 0;
          font-size: 26px;
          font-weight: bold;
          line-height: 1.31;
          letter-spacing: -1px;
          text-align: right;
          color: $font-color;
        }

        .vat {
          margin: 4px 0;
          font-size: 12px;
          font-weight: normal;
          line-height: 1.33;
          letter-spacing: -0.3px;
          text-align: right;
          color: #adb5bd;
        }
      }

      .agreement {
        text-align: center;

        .checkbox {
          display: inline-block;
          top: 6px;
          margin: 0;
        }

        p {
          display: inline-block;
          margin-bottom: 24px;
          font-size: 16px;
          line-height: 1.5;
          letter-spacing: -1.3px;
          text-align: right;
          color: #212529;
        }

        a {
          font-weight: bold;
          color: #212529;
          text-decoration: underline;
        }

        button {
          width: 167px;
        }

        @media (max-width: 767px) {
          text-align: left;

          .hz-checkbox .checkmark { top: 3px; }

          p {
            margin-bottom: 12px;
            font-size: 14px;
          }

          button { width: 100%; }
        }
      }

      // 모바일에선 결제 영역이 Fixed 된다.
      @media (max-width: 767px) {
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 16px;
        z-index: 3;
        box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.16);
      }

      // iPhone 5 & SE
      @media (max-width: 330px) {
        .agreement p {
          font-size: 12px;
        }
      }
    }

    #couponModal {
      padding-top: 48px;

      .modal-header {
        padding: 24px 16px;
      }

      .modal-title {
        font-size: 22px;
        font-weight: bold;
      }

      .modal-content {
        max-width: 539px;
      }

      .modal-body {
        .col-sm-8 { padding: 0; }
        .col-sm-4 { padding: 0 4px; }
      }

      .modal-footer {
        padding: 16px;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.71;
        letter-spacing: -0.7px;
        color: #54595f;
        text-align: left;

        .link {
          text-decoration: underline;
          font-weight: bold;
          color: #54595f;
        }
      }

      @media (max-width: 767px) {
        .modal-body {
          padding-top: 4px;
          padding-bottom: 0;
        }

        .modal-body .col-sm-4 {
          padding: 4px 0 0 0;
        }
      }
    }

    .sub-title {
      margin: 0;
      font-size: 22px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.36;
      letter-spacing: -1.1px;
      color: #2e3134;
    }

    .loader-wrap {
      position: relative;
      height: 240px;

      .loader-content {
        position: absolute;
        top: calc(50% - 32px);
        left: calc(50% - 32px);
        transform: translate(-50%, -50%);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pricing/Pricing.vue